module.exports = __webpack_public_path__ + "img/idCard-outline-black.7cef79b5.svg";